import * as React from 'react';

export default class A2ZSort extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
        <path fill="#000" strokeWidth="0" fillRule="evenodd" d="M13.4 14.515l-.398-1.032h-2.565l-.398 1.032H9l2.127-5.38h1.185l2.127 5.38H13.4zm-1.68-4.581l-1.015 2.718h2.03L11.72 9.934z" clipRule="evenodd"/>
        <path fill="#43ADF1" strokeWidth="0" fillRule="evenodd" d="M10 6.567v-.766l2.768-3.783H10v-.83h4.002v.765l-2.768 3.783h2.825v.831H10z" clipRule="evenodd"/>
        <path stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M5.055 1.736V13.57M1.762 11.3l3.29 2.902L8.34 11.3"/>
      </svg>
    )
  }
}
